//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VocLayoutBasic",
  props: {
    // header高度
    headerHeight: {
      type: String,
      default: "50px"
    },
    // 侧边栏宽度
    asideWidth: {
      type: String,
      default: ""
    }
  }
}
